export default __webpack_public_path__ + "939976ad64e2b4f0382953fcfc69d5ae.svg";